// @flow
import { ReactNode, Suspense } from "react";

type Props = {
	component: ReactNode;
};
export const LazyLoading = ({ component }: Props) => {
	return <Suspense fallback={<div>Loading...</div>}>{component}</Suspense>;
};
